import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { FaUniversalAccess } from "react-icons/fa";


/* ================= CSS ================= */

const AccessibilityStyles = styled.div`

.high-contrast #site-content,
.high-contrast #site-content *:not(#a11y-panel):not(#a11y-panel *) {
    filter: contrast(160%);
}


.dark-mode #site-content,
.dark-mode #site-content *:not(#a11y-panel):not(#a11y-panel *) {
    background:#111 !important;
    color:white !important;
}


.gray-mode #site-content {
    filter: grayscale(100%);
}


.easy-font #site-content,
.easy-font #site-content * {
    font-family: Arial, Tahoma, sans-serif !important;
}


.letter-space #site-content * {
    letter-spacing:3px!important;
}


.line-space #site-content * {
    line-height:2!important;
}


.bold-text #site-content * {
    font-weight:900!important;
}


.big-text #site-content {
    font-size:125%!important;
}


.hide-images #site-content img {
    display:none!important;
}


.highlight-links #site-content a {

text-decoration:underline!important;
color:#0066ff!important;
font-weight:bold!important;

}


/* חדש */

.stop-animation #site-content *,
.stop-animation #site-content *::before,
.stop-animation #site-content *::after {

animation:none!important;
transition:none!important;

}


.highlight-headings #site-content h1,
.highlight-headings #site-content h2,
.highlight-headings #site-content h3,
.highlight-headings #site-content h4,
.highlight-headings #site-content h5,
.highlight-headings #site-content h6 {

background:#ffff00!important;
color:#000!important;

}


.big-cursor #site-content,
.big-cursor #site-content * {

cursor:pointer!important;

}


.read-focus #site-content *:focus {

outline:4px solid #008cff!important;

}


`;


/* ================= BUTTON ================= */

const Button = styled.button`

position:fixed;
left:20px;
bottom:20px;

width:85px;
height:85px;

border-radius:50%;
border:none;

background:transparent;

color:white;
cursor:pointer;

z-index:999999;

display:flex;
align-items:center;
justify-content:center;

animation:none;
transition:.3s;

svg {
    font-size:65px;
    filter:none;
}

&:hover {
    transform:scale(1.05);
}

`;

/* ================= BOX ================= */

const Box = styled.div`

position:fixed;

top:0;
left:0;

width:380px;

max-width:100vw;

height:100dvh;


overflow:auto;

padding:25px;

box-sizing:border-box;


background:linear-gradient(145deg,#ffffff,#eaf7ff);

color:#111;


z-index:999998;


border-right:3px solid #008cff;


box-shadow:5px 0 25px rgba(0,0,0,.25);


transform:${p=>p.open?
"translateX(0)"
:
"translateX(-110%)"
};


transition:.5s;


font-family:Arial;



.title{

text-align:center;

font-size:32px;

font-weight:900;

margin-bottom:25px;

color:#008cff;

text-shadow:

0 0 10px #00c8ff,
0 0 20px rgba(0,140,255,.5);

}



.close{

position:absolute;

right:20px;

top:20px;


width:35px;

height:35px;

border-radius:50%;

border:none;

background:#ddd;

cursor:pointer;

font-size:18px;

}



.buttonsGrid{

display:grid;

grid-template-columns:repeat(2,1fr);

gap:12px;

}



button:not(.close){

min-height:60px;

border:none;

border-radius:14px;

background:#ffffff;

color:#003b80;

font-size:17px!important;

font-weight:800;

cursor:pointer;

border:1px solid #ccc;

transition:.2s;

}



button.active{

background:#008cff!important;

color:white!important;

box-shadow:

0 0 10px #00c8ff;

}



button:not(.close):hover{

background:#e8f4ff;

}



.zoom{

text-align:center;

font-size:22px;

font-weight:bold;

margin-bottom:20px;

}



@media(max-width:600px){

width:80vw;


.buttonsGrid{

grid-template-columns:1fr;

}

}


`;



/* ================= COMPONENT ================= */


export default function AccessibilityWidget(){


const [open,setOpen]=useState(false);


const [zoom,setZoom]=useState(100);


const [fontSize,setFontSize]=useState(100);


const [active,setActive]=useState({});



const speechRef=useRef(null);



const getSite=()=>document.getElementById("site-content");



const saveSettings=(data)=>{

const old=
JSON.parse(
localStorage.getItem("a11ySettings")||"{}"
);


localStorage.setItem(
"a11ySettings",
JSON.stringify({
...old,
...data
})
);


};


/* ================= ZOOM ================= */

const applyZoom=(value)=>{

const site=getSite();

if(!site)return;


if(value===100){

site.style.removeProperty("transform");

site.style.removeProperty("width");

site.style.removeProperty("transform-origin");

return;

}


site.style.transformOrigin="top left";

site.style.transform=`scale(${value/100})`;

site.style.width=`${100/(value/100)}%`;

};


useEffect(()=>{


const site=getSite();

if(!site)return;


const saved=
JSON.parse(
localStorage.getItem("a11ySettings")||"{}"
);



if(saved.zoom){

setZoom(saved.zoom);

applyZoom(saved.zoom);

}



if(saved.fontSize){

setFontSize(saved.fontSize);

site.style.fontSize=saved.fontSize+"%";

}



Object.keys(saved).forEach(key=>{


if(saved[key]===true){

site.classList.add(key);

}

});


setActive(saved);



},[]);






const changeZoom=(num)=>{


let value=zoom+num;


if(value<80)value=80;

if(value>160)value=160;


setZoom(value);


applyZoom(value);


saveSettings({

zoom:value

});


};



/* ================= FONT ================= */


const changeFontSize=(value)=>{


const site=getSite();


if(!site)return;


if(value<90)value=90;


if(value>170)value=170;



site.style.fontSize=value+"%";


setFontSize(value);


saveSettings({

fontSize:value

});


};



/* ================= TOGGLE ================= */


const toggle=(name)=>{


const site=getSite();


if(!site)return;



const enabled=
!site.classList.contains(name);



site.classList.toggle(name);



setActive(prev=>({

...prev,

[name]:enabled

}));



saveSettings({

[name]:enabled

});


};



/* ================= SPEECH ================= */


const readPage = () => {

if(!window.speechSynthesis) return;


window.speechSynthesis.cancel();


const site = getSite();


if(!site) return;


const text = site.innerText;


if(!text) return;



const speech = new SpeechSynthesisUtterance(text);


speech.lang = "he-IL";

speech.rate = 1;


speechRef.current = speech;


window.speechSynthesis.speak(speech);

};



const stopReading=()=>{


if(window.speechSynthesis){

window.speechSynthesis.cancel();

}


};



/* ================= RESET ================= */


const reset=()=>{


const site=getSite();


if(site){


[

"high-contrast",

"dark-mode",

"gray-mode",

"easy-font",

"letter-space",

"line-space",

"bold-text",

"big-text",

"hide-images",

"highlight-links",

"stop-animation",

"highlight-headings",

"big-cursor",

"read-focus"

].forEach(c=>{

site.classList.remove(c);

});



site.style.removeProperty("transform");

site.style.removeProperty("width");

site.style.removeProperty("font-size");

site.style.removeProperty("transform-origin");


}



localStorage.removeItem("a11ySettings");



setZoom(100);

setFontSize(100);

setActive({});


};



/* ================= UI ================= */


return createPortal(

<>

{

!open &&

(

<Button

onClick={()=>setOpen(true)}

>

<FaUniversalAccess/>

</Button>

)

}



<AccessibilityStyles>


<Box

open={open}

id="a11y-panel"

>


<div className="title">

נגישות

</div>



<button

className="close"

onClick={()=>setOpen(false)}

>

✕

</button>



<div className="zoom">

🔍 זום {zoom}%

</div>




<div className="buttonsGrid">



<button

onClick={()=>changeZoom(10)}

>

🔍 הגדלת מסך

</button>



<button

onClick={()=>changeZoom(-10)}

>

🔎 הקטנת מסך

</button>



<button

onClick={()=>{

setZoom(100);

applyZoom(100);

saveSettings({

zoom:100

});

}}

>

↩ איפוס זום

</button>




<button

onClick={()=>changeFontSize(fontSize+10)}

>

🔠 הגדלת כתב

</button>



<button

onClick={()=>changeFontSize(fontSize-10)}

>

🔡 הקטנת כתב

</button>





<button

className={active["high-contrast"]?"active":""}

onClick={()=>toggle("high-contrast")}

>

⚫ ניגודיות גבוהה

</button>




<button

className={active["dark-mode"]?"active":""}

onClick={()=>toggle("dark-mode")}

>

🌙 מצב כהה

</button>





<button

className={active["gray-mode"]?"active":""}

onClick={()=>toggle("gray-mode")}

>

⚪ גווני אפור

</button>





<button

className={active["easy-font"]?"active":""}

onClick={()=>toggle("easy-font")}

>

📖 גופן קריא

</button>





<button

className={active["bold-text"]?"active":""}

onClick={()=>toggle("bold-text")}

>

🅱 כתב מודגש

</button>




<button

className={active["big-text"]?"active":""}

onClick={()=>toggle("big-text")}

>

🔠 טקסט גדול

</button>




<button

className={active["hide-images"]?"active":""}

onClick={()=>toggle("hide-images")}

>

🖼 הסתרת תמונות

</button>



<button

className={active["highlight-links"]?"active":""}

onClick={()=>toggle("highlight-links")}

>

🔗 קו תחתון לקישורים

</button>



<button

className={active["stop-animation"]?"active":""}

onClick={()=>toggle("stop-animation")}

>

⏸ ביטול אנימציות

</button>



<button

className={active["highlight-headings"]?"active":""}

onClick={()=>toggle("highlight-headings")}

>

🟨 הדגשת כותרות

</button>



<button

className={active["big-cursor"]?"active":""}

onClick={()=>toggle("big-cursor")}

>

🖱 סמן גדול

</button>



<button

className={active["letter-space"]?"active":""}

onClick={()=>toggle("letter-space")}

>

↔ ריווח אותיות

</button>



<button

className={active["line-space"]?"active":""}

onClick={()=>toggle("line-space")}

>

↕ ריווח שורות

</button>



<button

className={active["read-focus"]?"active":""}

onClick={()=>toggle("read-focus")}

>

🎯 הדגשת פוקוס

</button>



<button

onClick={readPage}

>

🔊 הקראת טקסט

</button>



<button

onClick={stopReading}

>

⏹ עצירת הקראה

</button>



<button

onClick={reset}

>

♻ איפוס הכל

</button>



</div>


</Box>


</AccessibilityStyles>


</>,


document.body

);


}
























